import { useContext } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ModalKey, ModalContext } from 'components/Modals/ModalContext'
import { APIContext } from 'context/APIContext'
import { removeWorkoutV5FromSlice } from 'redux/slices/activeWorkoutV5'

import SolidButton from 'components/Buttons/SolidButton'
import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function ActiveWorkoutV5Header({
    kinesisWorkoutAssignmentType,
    groupId,
    athleteId,
    workoutId,
    activeWorkout
}) {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { ShowModal } = useContext(ModalContext)

    const { DiscardActiveWorkoutV5, SaveV5Workouts } = useContext(APIContext)

    const ShowDiscardActiveWorkoutWarningModal = () => {
        const modalData = {
            key: ModalKey.ActionWarning,
            fullscreen: false,
            size: 'quarter',
            titleText: 'Discard Workout?',
            bodyText: [
                'Are you sure you want to discard this workout?',
                'Any progress made during the workout will be lost.'
            ],
            buttonText: 'Discard',
            buttonAction: async () => await __DiscardActiveWorkout()
        }

        ShowModal(modalData)
    }

    const __DiscardActiveWorkout = async () => {

        var workoutIdsToDiscard = [workoutId]

        for (const groupIndividual of activeWorkout.groupIndividuals ?? []) {
            workoutIdsToDiscard.push(groupIndividual.workout.workoutId)
        }

        const workoutsDiscarded = await DiscardActiveWorkoutV5(workoutIdsToDiscard)

        if (workoutsDiscarded === false) {
            console.error('Failed to discard workout!')
            return
        }

        const discardPayload = {
            workoutId: workoutId
        }

        dispatch(removeWorkoutV5FromSlice(discardPayload))

        navigate('/workout/' + workoutId + '/preview')
        
    }

    const ShowEndActiveWorkoutWarningModal = () => {
        const modalData = {
            key: ModalKey.ActionWarning,
            fullscreen: false,
            size: 'quarter',
            titleText: 'End Workout?',
            bodyText: [
                'Are you sure you want to end this workout?',
                'All saved sets will be stored.',
                'Any incomplete or skipped sets will be discarded.'
            ],
            buttonText: 'End',
            buttonAction: async () => await __EndActiveWorkout()
        }

        ShowModal(modalData)
    }

    const __EndActiveWorkout = async () => {
        
        const workouts = []

        if (kinesisWorkoutAssignmentType === 'group') {
            for (const groupIndividual of activeWorkout.groupIndividuals ?? []) {
                workouts.push(groupIndividual.workout)
            }
        }

        if (kinesisWorkoutAssignmentType === 'individual') {
            workouts.push(activeWorkout.workout)
        }

        /*
        const workoutDataJson = JSON.stringify(workouts)
        const jsonBytes = new TextEncoder().encode(workoutDataJson).length
        const jsonKilobytes = jsonBytes / 1024
        const jsonMegabytes = jsonBytes / (1024 * 1024)

        console.log('[EndActiveWorkout] workouts JSON size:', {
            bytes: jsonBytes,
            kilobytes: Number(jsonKilobytes.toFixed(2)),
            megabytes: Number(jsonMegabytes.toFixed(4)),
        })
        */

        const savedWorkouts = await SaveV5Workouts(workouts)

        if (savedWorkouts === false) {
            console.error('Failed to save workouts!')
            return
        }

        const discardPayload = {
            workoutId: workoutId
        }

        dispatch(removeWorkoutV5FromSlice(discardPayload))

        if (kinesisWorkoutAssignmentType === 'group') {
            navigate('/group/' + groupId)
        }

        if (kinesisWorkoutAssignmentType === 'individual') {
            navigate('/athlete/' + athleteId)
        }
    }

    return (
        <div className="flex items-center mb-6 gap-x-4">
            <h1 className="flex-1 min-w-0">
                <p className='text-3xl font-bold max-w-[55vw] 2xl:max-w-[50vw] truncate'>
                    {kinesisWorkoutAssignmentType === 'group' && <>{activeWorkout?.groupDetails?.name} - {activeWorkout?.workout?.name}</>}
                    {kinesisWorkoutAssignmentType === 'individual' && <>{activeWorkout?.userDetails?.firstName} {activeWorkout?.userDetails?.lastName} - {activeWorkout?.workout?.name}</>}
                </p>
            </h1>

            <div className='w-40'>
                <SolidButton
                    size="large"
                    text="Discard"
                    className='shadow-md'
                    action={ShowDiscardActiveWorkoutWarningModal}
                />
            </div>

            <div className='w-40'>
                <BrandColorButton
                    size="large"
                    text="End"
                    className="shadow-md"
                    action={ShowEndActiveWorkoutWarningModal}
                />
            </div>
        </div>
    )
}